var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62695 7.82593L3.62695 6.82593L4.62695 7.82593",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.373 7.85339L12.373 8.85339L11.373 7.85339",
    stroke: "#0F4AA2",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0575 10.1824C12.2847 10.3135 12.3643 10.6056 12.2122 10.8194C11.6056 11.6716 10.744 12.3157 9.74592 12.6545C8.59725 13.0444 7.34601 13.0035 6.2253 12.5393C5.1046 12.0751 4.19087 11.2193 3.65436 10.1313C3.18816 9.18595 3.0344 8.12134 3.2081 7.08976C3.25166 6.83106 3.51451 6.68082 3.76791 6.74872C4.0213 6.81661 4.16871 7.07704 4.13093 7.33664C4.01339 8.14421 4.14218 8.97261 4.50639 9.71114C4.94096 10.5924 5.68108 11.2856 6.58885 11.6616C7.49662 12.0376 8.51013 12.0708 9.44055 11.7549C10.2203 11.4902 10.8971 10.9956 11.3851 10.3414C11.5419 10.1311 11.8303 10.0512 12.0575 10.1824Z",
    fill: "#0F4AA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94251 5.49695C3.71533 5.36578 3.6357 5.07368 3.78783 4.85995C4.39444 4.0077 5.25596 3.36362 6.25408 3.0248C7.40275 2.63488 8.65399 2.67584 9.7747 3.14005C10.8954 3.60426 11.8091 4.46006 12.3456 5.54801C12.8118 6.49337 12.9656 7.55798 12.7919 8.58956C12.7483 8.84826 12.4855 8.9985 12.2321 8.9306C11.9787 8.86271 11.8313 8.60228 11.8691 8.34268C11.9866 7.53511 11.8578 6.70672 11.4936 5.96818C11.059 5.08695 10.3189 4.39375 9.41115 4.01774C8.50338 3.64173 7.48987 3.60855 6.55945 3.92438C5.77969 4.18907 5.10286 4.68377 4.61493 5.33792C4.45808 5.5482 4.1697 5.62812 3.94251 5.49695Z",
    fill: "#0F4AA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRegenerate);
export default __webpack_public_path__ + "static/media/ai-regenerate.b910fe552dfb603674e7c2e551104f49.svg";
export { ForwardRef as ReactComponent };